import { useDatadome } from '@search/core/hooks/useDatadome';
import { useHotjar } from '@search/core/hooks/useHotjar';
import { useTracking } from '../../tracking/useTracking';
import { useContainedClassifieds } from '../analytics/useContainedClassifieds';
import { useAds } from '../useAds';
import { useAutoScroll } from '../useAutoScroll';
import { useLastSearches } from '../useLastSearches';
import { useRouter } from '../useRouter';
import { useSerpData } from '../useSerpData';
// Centralize all SERP necessary hooks in one place
export const useSerp = () => {
    // Update the data depending on the models changed
    useSerpData();
    useContainedClassifieds();
    useLastSearches();
    useAutoScroll();
    useAds();
    useHotjar();
    useTracking();
    useRouter();
    useDatadome();
};
